var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "call",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27748",
    "data-name": "Path 27748",
    d: "M0,0H20V20H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27749",
    "data-name": "Path 27749",
    d: "M5.753,4.556A9.576,9.576,0,0,0,6.1,6.57L5.17,7.5a11.531,11.531,0,0,1-.591-2.948H5.753M13.422,13.9a9.919,9.919,0,0,0,2.022.35v1.159a12,12,0,0,1-2.956-.583l.933-.926M6.5,3H3.778A.78.78,0,0,0,3,3.778,13.221,13.221,0,0,0,16.222,17,.78.78,0,0,0,17,16.222V13.508a.78.78,0,0,0-.778-.778,8.872,8.872,0,0,1-2.777-.443.653.653,0,0,0-.241-.039.8.8,0,0,0-.552.226l-1.711,1.711A11.782,11.782,0,0,1,5.816,9.059L7.527,7.348a.781.781,0,0,0,.194-.793,8.836,8.836,0,0,1-.443-2.777A.78.78,0,0,0,6.5,3Z",
    transform: "translate(0 0)",
    fill: "#19bc9c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.fe83ea824e7adeed4084e2995b065e3c.svg";
export { ForwardRef as ReactComponent };